// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UpgradeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UpgradeIcon" ref={forwardedRef} {...props}>
      <path d="M9.501 1.44a.76.76 0 0 1 .998 0l.058.057 6.488 6.976a.76.76 0 0 1-.557 1.277h-2.725L13.753 13H6.245V9.75H3.512a.76.76 0 0 1-.557-1.277l6.487-6.976zM5.212 8.25h2.534v3.25h4.51l.008-3.25h2.524L10 3.102z" />
      <path d="M6.245 14.5h7.508V16H6.245z" />
      <path d="M6.995 17.5h6.009V19h-6.01z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const UpgradeIcon = /* @__PURE__ */ Object.assign(UpgradeIconComponent, {
  displayName: 'UpgradeIcon',
});
